import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

// Читаем ?lang= из URL при первом запуске (передаётся с лендинга)
const urlLang = new URLSearchParams(window.location.search).get('lang');
const SUPPORTED = ['ru', 'en'];
// Дефолт: сохранённый язык → ?lang= из URL → ru
const savedLang = localStorage.getItem('pm_lang');
const initialLang = SUPPORTED.includes(urlLang) ? urlLang : SUPPORTED.includes(savedLang) ? savedLang : 'ru';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: initialLang,
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false, // React сам экранирует
    },
  });

// <html lang> должен совпадать с языком интерфейса. Был зашит lang="ru" в
// index.html — Edge/Chrome считали английский интерфейс русской страницей и
// на каждой новой вкладке предлагали «перевести на английский» (фидбек
// Global, 23.10.2026). Ставим на старте и на каждой смене языка.
// Язык из профиля (useAuth) тоже запоминаем в pm_lang — иначе до ответа
// /auth/me страница грузится как ru и ещё раз мигает языком.
const syncHtmlLang = (lng) => {
  if (!lng) return;
  const code = String(lng).split('-')[0];
  document.documentElement.setAttribute('lang', code);
  if (SUPPORTED.includes(code)) {
    try { localStorage.setItem('pm_lang', code); } catch { /* приватный режим */ }
  }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
